import { Loadable } from '@/components/loaders';
import { useWorkspace } from '@/features/workspaces/hooks';
import { Card } from '@/lib';
import { AudienceEstimateIcon } from '@/lib/Icons/Icons/Icons';
import { Audience } from '@/models/audiences';
import { useGetEstimateQuery } from '@/services/endpoints/audiences';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type AudienceEstimateCardProps = {
  audience: Audience;
};

export const AudienceEstimateCard: FC<AudienceEstimateCardProps> = ({ audience }) => {
  const { t } = useTranslation();
  const workspace = useWorkspace();

  const { data: audienceEstimate, isLoading: isAudienceEstimateLoading } = useGetEstimateQuery({
    workspaceId: workspace.id,
    audienceId: audience.id,
  });

  return (
    <Card className='flex-col gap-3'>
      <h3 className='font-medium text-secondary-700 '>{t('audience_details:sources_and_rules.unique_users')}</h3>
      <div className='flex items-center gap-3 text-brand-600'>
        <span className='rounded-full bg-brand-100 p-2.5 '>
          <AudienceEstimateIcon className='size-5' />
        </span>
        <Loadable isLoading={isAudienceEstimateLoading}>
          <p className='text-lg font-semibold'>{audienceEstimate?.size}</p>
        </Loadable>
      </div>
    </Card>
  );
};
